import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { SITE, FOOTER_LINKS } from "../data/site";

const FooterLink = ({ link, testId }) =>
  link.external ? (
    <a
      href={link.href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className="block text-sm text-white/70 hover:text-gold transition-colors duration-300 py-1"
    >
      {link.label}
    </a>
  ) : (
    <Link
      to={link.href}
      data-testid={testId}
      className="block text-sm text-white/70 hover:text-gold transition-colors duration-300 py-1"
    >
      {link.label}
    </Link>
  );

export const Footer = () => (
  <footer
    className="bg-navy text-white"
    data-testid="site-footer"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-12 pb-10">
      <div className="grid grid-cols-2 gap-x-8 gap-y-12 md:flex md:flex-wrap md:gap-x-16 lg:gap-x-24 md:gap-y-10">
        <div className="md:w-auto">
          <Link to="/" data-testid="footer-logo-link">
            <img
              src={SITE.logo}
              alt="Lunar Ambitions"
              className="h-20 sm:h-24 w-auto brightness-0 invert"
            />
          </Link>
          <p
            className="mt-6 text-sm text-white/70"
            data-testid="footer-location-text"
          >
            Orlando, FL
          </p>
          <a
            href={SITE.phoneHref}
            className="mt-1 inline-block text-sm text-white/70 hover:text-gold transition-colors duration-300"
            data-testid="footer-phone-text"
          >
            (407) 538-9402
          </a>
          <div className="mt-6 flex items-center gap-4">
            <a
              href={SITE.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Lunar Ambitions on Instagram"
              data-testid="footer-instagram-link"
              className="text-white/70 hover:text-gold transition-colors duration-300"
            >
              <Instagram size={20} strokeWidth={1.5} />
            </a>
            <a
              href={SITE.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Lunar Ambitions on Facebook"
              data-testid="footer-facebook-link"
              className="text-white/70 hover:text-gold transition-colors duration-300"
            >
              <Facebook size={20} strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <div className="md:w-auto">
          <p className="text-xs tracking-[0.28em] uppercase text-gold font-medium mb-5">
            Studio
          </p>
          {FOOTER_LINKS.studio.map((link) => (
            <FooterLink
              key={link.href}
              link={link}
              testId={`footer-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}-link`}
            />
          ))}
        </div>

        <div className="md:w-auto">
          <p className="text-xs tracking-[0.28em] uppercase text-gold font-medium mb-5">
            Legal
          </p>
          {FOOTER_LINKS.legal.map((link) => (
            <FooterLink
              key={link.href}
              link={link}
              testId={`footer-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}-link`}
            />
          ))}
        </div>

        <div className="md:w-auto">
          <p className="text-xs tracking-[0.28em] uppercase text-gold font-medium mb-5">
            Gifts
          </p>
          {FOOTER_LINKS.gifts.map((link) => (
            <FooterLink
              key={link.href}
              link={link}
              testId={`footer-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}-link`}
            />
          ))}
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-white/50 tracking-wide">
          Lunar Ambitions · Facials, Nano Needling & Dermaplaning · Orlando, FL
        </p>
        <p className="text-xs text-white/40">
          &copy; {new Date().getFullYear()} Lunar Ambitions
        </p>
      </div>
    </div>
  </footer>
);
